import { render, staticRenderFns } from "./newSpecialties.vue?vue&type=template&id=592d263f&scoped=true"
import script from "./newSpecialties.vue?vue&type=script&scoped=true&lang=js"
export * from "./newSpecialties.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./newSpecialties.vue?vue&type=style&index=0&id=592d263f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d263f",
  null
  
)

export default component.exports